import { IdType } from 'types/enums';

const getIdTypesLabel = (type: IdType) => {
  switch (type) {
    case IdType.IPI:
      return 'IPI';
    case IdType.IPN:
      return 'IPN';
    case IdType.ISNI:
      return 'ISNI';
    default:
      throw Error('No id type defined');
  }
};

export const getDeleteMessage = (
  type: IdType,
  idNumber?: number | string
) => `Are you sure you want to delete the ${getIdTypesLabel(type)} ${
  idNumber || ''
}? It will be removed as default in your profile, 
        but where already used in Songs it will remain for credits.`;
